<script>
    import PageTransition from "../components/PageTransition.svelte";
    import DiscordPage from "../components/DiscordPage.svelte";
    import { onMount } from "svelte";

    onMount(() => {
    window.scrollTo(0, 0);
    });
</script>
<head>
    <style>
        /* width */
        ::-webkit-scrollbar {
            width: 10px;
        }

        /* Track */
        ::-webkit-scrollbar-track {
            background: #3B375E;
            /*border-radius: 10px;*/
        }

        /* Handle */
        ::-webkit-scrollbar-thumb {
            background: #68638D;
            border-radius: 10px;
        }

        /* Handle on hover */
        ::-webkit-scrollbar-thumb:hover {
            background: #9992BF;
        }
    </style>
    <link rel='stylesheet' href='global.css'>
	<link rel='stylesheet' href='build/bundle.css'>
    <link rel="canonical" href="https://fyrehost.net/discord" />
    <meta name="description" content="Cheap and Fast Discord Bot Hosting with Low Ping and Lifetime Pricing!">
</head>
<div>

</div>
<PageTransition>
    <DiscordPage
            name="Discord Bot" 
            description="Discord Bot Hosting with support for Javascript, Python, Go, and Java. Is your language not listed here? Make a ticket in our Discord and we will add it!" 
            price="1" 
            cpu="2 vCore" 
            ram="1GB DDR4"
            storage="Unmetered NvME SSD" 
            databases="10"
            backups="10"
            paymentLink="https://buy.stripe.com/8wM6qd2O58Rxc6s7ss"
            class='p-3'
            paypalLink="https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-5T512289HG215725RMFJ4BPQ"
            >
        </DiscordPage>
</PageTransition>
